import React from 'react'
import DepotMovementsList from './components/Movements_list'

function DepotsMovemments() {
  return (
    <div>
        <DepotMovementsList />
    </div>
  )
}

export default DepotsMovemments
